import { Component, OnInit } from '@angular/core';
import { IonicModule, NavParams, ToastController } from '@ionic/angular';
import { ModalController } from '@ionic/angular'
import { FormBuilder, Validators, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { NgIf } from "@angular/common";
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  imports: [
    ReactiveFormsModule,
    IonicModule,
    NgIf,
    FormsModule
  ],
  standalone: true
})
export class LoginPage implements OnInit {
  mode: 'logging' | 'passReset' = 'logging'
  activeTab: 'login' | 'signup' = 'login'

  public loginForm: FormGroup
  public signupForm: FormGroup
  public passResetForm: FormGroup

  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController,
    private fb: FormBuilder,
    private authService: AuthService,
    private toast: ToastController
  ) {
    this.loginForm = this.fb.group({
      'email': [null, [Validators.required, Validators.email]],
      'pass': [null, [Validators.required, Validators.minLength(6)]]
    })

    this.signupForm = this.fb.group({
      'email': [null, [Validators.required, Validators.email]],
      'pass': [null, [Validators.required, Validators.minLength(6)]],
      'name': [null, [Validators.required]],
      'firstName': [null, [Validators.required]],
      'lastName': [null, [Validators.required]]
    })

    this.passResetForm = this.fb.group({
      'email': [null, [Validators.required, Validators.email]]
    })
  }

  ngOnInit() {
  }

  segmentChanged(event: any) {
    this.activeTab = event.detail.value;
  }

  private getErrorMessage(error: any): string {
    const code = error.code;
    switch (code) {
      case 'auth/wrong-password':
        return 'Nesprávné heslo. Pokud jste heslo zapomněli, použijte možnost "Zapomněli jste heslo?"';
      case 'auth/email-already-in-use':
        return 'Tento email je již registrován. Prosím přihlaste se, nebo použijte jiný email.';
      case 'auth/user-not-found':
        return 'Uživatel s tímto emailem není registrován.';
      case 'auth/too-many-requests':
        return 'Příliš mnoho pokusů o přihlášení. Zkuste to prosím později.';
      case 'auth/invalid-email':
        return 'Neplatná emailová adresa.';
      case 'auth/weak-password':
        return 'Heslo je příliš slabé. Použijte alespoň 6 znaků.';
      case 'auth/network-request-failed':
        return 'Problém s připojením k internetu. Zkontrolujte prosím své připojení.';
      case 'auth/popup-closed-by-user':
        return 'Přihlášení bylo přerušeno. Zkuste to prosím znovu.';
      default:
        return `Nastala chyba: ${error.message}`;
    }
  }

  async login() {
    try {
      await this.authService.signInWithEmailAndPassword(
        this.loginForm.value.email, 
        this.loginForm.value.pass
      )
      if (await this.loginCheck()) {
        await this.modalCtrl.dismiss()
      }
    } catch (error: any) {
      this.showToast(this.getErrorMessage(error))
    }
  }

  async signup() {
    try {
      await this.authService.createUserWithEmailAndPassword(
        this.signupForm.value.email,
        this.signupForm.value.pass,
        this.signupForm.value.name,
        this.signupForm.value.firstName,
        this.signupForm.value.lastName
      )
      await this.modalCtrl.dismiss()
    } catch (error: any) {
      this.showToast(this.getErrorMessage(error))
    }
  }

  async loginCheck() {
    return true
  }

  async resetPassword() {
    try {
      await this.authService.resetPassword(this.passResetForm.value.email)
      this.showToast('Email pro obnovení hesla byl odeslán.')
      this.switchModeToLogin()
    } catch (error: any) {
      this.showToast(this.getErrorMessage(error))
    }
  }

  switchModeToPassReset() {
    this.mode = 'passReset'
  }

  switchModeToLogin() {
    this.mode = 'logging'
    this.activeTab = 'login'
  }

  private async showToast(message: string) {
    const toast = await this.toast.create({
      message: message,
      duration: 3000,
      position: 'bottom'
    })
    await toast.present()
  }
}
